import styled from "styled-components";

export const SOnboardinbFormInputsAndTemplate = styled.div`
  display: flex;
  gap: 24px;
`;
